import {
  ProductColumns,
  ProductUsecaseInterface,
  UpdateListParams,
  UpdateParams,
  UpdateStatusParams,
} from "./usecase.d";
import { ProductRepository } from "../../services/Product/product.repository";
import * as ProductReducer from "./reducer";
import { ActionType } from "./types";
import { GetListParams } from "../../services/Product/product.repository.d";
import { LocalStorage } from "../../modules/LocalStorage";
import { GetProductDto } from "../../services/Product/dto/get.dto";

const PRODUCT_COLUMN_KEY = "ProductColumns";

const defaultColumns: ProductColumns = {
  productKey: true,
  name: true,
  productPrice: true,
  productWidth: false,
  productHeight: false,
  productDepth: false,
  productThumbnailUrl: true,
  productCategories: true,
  productRooms: true,
  productSurfaces: true,
  productManufacturer: true,
  homeNames: true,
  updatedByFullName: true,
  updatedAt: true,
  isActive: true,
};

export class ProductUsecase implements ProductUsecaseInterface {
  dispatch: ProductReducer.ProductDispatch;
  repository: ProductRepository;

  constructor(dispatch: ProductReducer.ProductDispatch) {
    this.repository = new ProductRepository();
    this.dispatch = dispatch;
  }

  async getList(params: GetListParams): Promise<GetProductDto[]> {
    const response = await this.repository.getList(params);

    this.dispatch({
      type: ActionType.GetList,
      items: response,
    });
    return response;
  }

  async update(params: UpdateParams) {
    try {
      const response = await this.repository.update({
        productKey: params.productKey,
        name: params.name,
        productPrice: params.productPrice,
        productWidth: params.productWidth,
        productHeight: params.productHeight,
        productDepth: params.productDepth,
        isActive: params.isActive,
        userId: params.userId,
      });
      this.dispatch({
        type: ActionType.Update,
        updatedItem: response.data,
      });
    } catch (error) {
      console.info("ahihi");
      throw error;
    }
  }

  async updateList(params: UpdateListParams) {
    try {
      const response = await this.repository.updateList({
        userId: params.userId,
        items: params.items,
      });
      this.dispatch({
        type: ActionType.UpdateList,
        updatedItems: response.data.Items,
      });
    } catch (error) {
      console.info("ahihi");
      throw error;
    }
  }

  async updateStatus(params: UpdateStatusParams) {
    this.dispatch({
      type: ActionType.UpdateStatus,
      updatedStatusItem: params,
    });

    try {
      await this.repository.update({
        productKey: params.productKey,
        isActive: params.isActive,
      });
    } catch (error) {
      this.dispatch({
        type: ActionType.UpdateStatus,
        updatedStatusItem: {
          productKey: params.productKey,
          isActive: !params.isActive,
        },
      });
      throw error;
    }
  }

  getDisplayColumns() {
    const columns =
      LocalStorage.getShowHideColumns<ProductColumns>(PRODUCT_COLUMN_KEY);

    if (
      !columns ||
      Object.keys(defaultColumns).length !== Object.keys(columns).length
    ) {
      return defaultColumns;
    }
    return columns;
  }

  setDisplayColumns(columns: ProductColumns) {
    LocalStorage.setShowHideColumns(PRODUCT_COLUMN_KEY, columns);
  }
}
